<template>
  <div>
    <div v-if="report.field_type === 'SENSOR_LIST'">
      <span class="body-2 black--text">
        {{ report.field_title }}
      </span>
      <v-list-item v-for="(sensorItem, ind) in report.sensor_list" :key="ind">
        <v-list-item-avatar class="mt-0 mb-0">
          <div v-if="!!reportIcon(sensorItem)">
            <v-icon :color="reportIcon(sensorItem).color">
              {{ reportIcon(sensorItem).icon }}
            </v-icon>
          </div>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-capitalize">{{
            sensorItem.sensor_name
          }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="!!reportTextSensors(sensorItem)">
          <v-chip>{{ reportTextSensors(sensorItem) }}</v-chip>
        </v-list-item-action>
      </v-list-item>
    </div>
    <div v-if="report.field_type === 'GPS_CONTENT'">
      <span class="body-2 black--text">
        {{ $t("components.miscellaneous.diagnosticsReportsEntry.gpsStatus") }}
      </span>
      <v-list-item>
        <v-list-item-avatar class="mt-0 mb-0">
          <div v-if="!!reportIcon(report)">
            <v-icon :color="reportIcon(report).color">
              {{ reportIcon(report).icon }}
            </v-icon>
          </div>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-capitalize">
            {{
              $t("components.miscellaneous.diagnosticsReportsEntry.gpsSignal")
            }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="!!reportTextGps(report)">
          <v-chip>{{ reportTextGps(report) }}</v-chip>
        </v-list-item-action>
      </v-list-item>
    </div>
    <div v-if="report.field_type === 'NMEA_STATUS'">
      <span class="body-2 black--text">
        {{ $t("components.miscellaneous.diagnosticsReportsEntry.nmeaStatus") }}
      </span>
      <v-list-item>
        <v-list-item-avatar class="mt-0 mb-0">
          <div v-if="!!reportIcon(report, true)">
            <v-icon :color="reportIcon(report, true).color">
              {{ reportIcon(report, true).icon }}
            </v-icon>
          </div>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-capitalize">
            {{ reportTitleNmea(report) }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="!!reportTextNmea(report)">
          <v-chip>{{ reportTextNmea(report) }}</v-chip>
        </v-list-item-action>
      </v-list-item>
    </div>
    <div v-if="report.field_type === 'NMEA_SENSOR_LIST'">
      <span class="body-2 black--text">
        {{ $t("components.miscellaneous.diagnosticsReportsEntry.nmeaSensors") }}
      </span>
      <v-list-item v-for="(sensorItem, ind) in report.sensor_list" :key="ind">
        <v-list-item-avatar class="mt-0 mb-0">
          <div v-if="!!reportIcon(sensorItem)">
            <v-icon :color="reportIcon(sensorItem).color">
              {{ reportIcon(sensorItem).icon }}
            </v-icon>
          </div>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-capitalize">{{
            sensorItem.sensor_name
          }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="!!reportTextSensors(sensorItem)">
          <v-chip>{{ reportTextSensors(sensorItem) }}</v-chip>
        </v-list-item-action>
      </v-list-item>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    report: {
      type: Object,
      default: Object,
    },
    isTimedOut: {
      type: Boolean,
      default: Boolean,
    },
  },
  data() {
    return {
      knownSensorStatuses: [
        "TEST_MANUALLY",
        "MISSING",
        "FOUND",
        "LOADING",
        "NOT_TESTED",
        "FOUND_BAD",
      ],
    };
  },

  methods: {
    reportTitleNmea(sensor) {
      if (sensor.status === "FOUND" && sensor.nmea_online) {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.nmeaConnected"
        );
      }

      if (sensor.status === "FOUND" && !sensor.nmea_online) {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.nmeaDisconnected"
        );
      }

      if (sensor.status === "LOADING" && this.isTimedOut) {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.nmeaOnline"
        );
      }

      if (sensor.status === "LOADING" && !this.isTimedOut) {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.nmeaOnline"
        );
      }

      if (sensor.status === "FOUND_BAD") {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.foundBad"
        );
      }

      if (sensor.status === "MISSING") {
        return null;
      }

      if (sensor.status === "TEST_MANUALLY") {
        return null;
      }

      if (sensor.status === "NOT_TESTED") {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.nmeaStatusUnknown"
        );
      }
    },
    reportTextNmea(sensor) {
      if (sensor.status === "LOADING" && this.isTimedOut) {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.timedOut"
        );
      }

      if (sensor.status === "FOUND_BAD") {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.foundBad"
        );
      }

      if (sensor.status === "MISSING") {
        return null;
      }

      if (sensor.status === "TEST_MANUALLY") {
        return null;
      }

      if (sensor.status === "NOT_TESTED") {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.aborted"
        );
      }
    },
    reportTextGps(sensor) {
      if (
        sensor.status === "FOUND" &&
        sensor.gps_percentage !== null &&
        sensor.gps_percentage !== ""
      ) {
        return sensor.gps_status;
      }

      if (sensor.status === "LOADING" && this.isTimedOut) {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.timedOut"
        );
      }

      if (sensor.status === "LOADING" && !this.isTimedOut) {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.gpsSignal"
        );
      }

      if (sensor.status === "FOUND_BAD") {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.gpsBadSignal"
        );
      }

      if (sensor.status === "MISSING") {
        return null;
      }

      if (sensor.status === "TEST_MANUALLY") {
        return null;
      }

      if (sensor.status === "NOT_TESTED") {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.aborted"
        );
      }
    },
    reportTextSensors(sensor) {
      if (sensor.sensor_value !== null && sensor.sensor_value !== "") {
        return sensor.sensor_value;
      }

      if (sensor.status === "LOADING" && this.isTimedOut) {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.timedOut"
        );
      }

      if (sensor.status === "LOADING" && !this.isTimedOut) {
        return null;
      }

      if (sensor.status === "MISSING") {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.notPresent"
        );
      }

      if (sensor.status === "TEST_MANUALLY") {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.testManually"
        );
      }

      if (sensor.status === "NOT_TESTED") {
        return this.$t(
          "components.miscellaneous.diagnosticsReportsEntry.aborted"
        );
      }
    },
    reportIcon(sensor, nmea = false) {
      const icons = [
        { type: "LOADING", icon: "mdi-loading", color: "primary" },
        { type: "FOUND", icon: "mdi-check-circle-outline", color: "green" },
        { type: "MISSING", icon: "mdi-close-circle-outline", color: "red" },
        {
          type: "TEST_MANUALLY",
          icon: "mdi-help-circle-outline",
          color: "orange",
        },
        {
          type: "FOUND_BAD",
          icon: "mdi-help-circle-outline",
          color: "orange",
        },
        {
          type: "NOT_TESTED",
          icon: "mdi-help-circle-outline",
          color: "orange",
        },
      ];

      const sensorIcon = icons.find((item) => {
        return item.type === sensor.status;
      });

      if (typeof sensorIcon === "undefined") {
        return null;
      }

      // HACK: handle GPS weak case
      if (
        sensorIcon.type === "FOUND" &&
        sensor.field_type === "GPS_CONTENT" &&
        sensor.gps_status &&
        sensor.gps_status.toLowerCase().includes("weak")
      ) {
        return {
          type: "FOUND_BAD",
          icon: "mdi-help-circle-outline",
          color: "orange",
        };
      }

      //HACK: handle special case
      if (sensorIcon.type === "FOUND" && nmea && !sensor.nmea_online) {
        return {
          type: "MISSING",
          icon: "mdi-close-circle-outline",
          color: "red",
        };
      }

      return sensorIcon;
    },
  },
};
</script>
<style lang=""></style>
